/* tslint:disable */
/* eslint-disable */
export enum VpnClientType {
  Gateway = 'GATEWAY',
  User = 'USER',
  Unknown = 'UNKNOWN'
}
